import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { actionCodeMenus } from "globals/configuration/pbxServiceMenu";
import formControl from "globals/form-control";

const Attributes = {
  formSize: "md",
  columns: 1,
  enableAddButton: true,
  enableAdvanceSearch: true,
  modes: actionCodeMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  list: "extensions/list/voiceGuidance",
  create: "extensions/create/voiceGuidance",
  delete: "extensions/delete/extension",
};

const getColumns = (onDelete) => {
  return [
    {
      Header: "Code",
      accessor: "extension",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Short Code",
      accessor: "extensionType",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
      controlType: "select",
      options: {
        keyField: "shortcode",
        keyDescription: "description",
        values: [],
        url: "actionCodeMaster/listAll/vg",
      },
    },
    {
      Header: "Description",
      accessor: "description",
      displayInList: true,
      allowFilter: false,
      allowInForm: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction row={row} value={value} onDelete={onDelete} />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
